var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DPill',{attrs:{"label":_vm.label,"icon":_vm.icon,"color":_vm.color}})
}
var staticRenderFns = []

export { render, staticRenderFns }